import { $, $$, setAttributes, closest } from 'utils/dom';
import { uniqueId } from 'utils/helper';
import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de.js';
import Shower from 'modules/shower';

// ---------- init form element accordions (for fieldsets of checkboxes or radio buttons)

const formfieldAccordions = $$('.form__element.is-collapsible');

if (formfieldAccordions.length) {
  formfieldAccordions.forEach(accordion => {
    const randomID = uniqueId();
    const target = $('fieldset', accordion);
    const handler = $('.input__toggle', accordion);

    setAttributes(handler, {
      id: `acc-btn-${randomID}`,
      'aria-controls': `acc-tab-${randomID}`,
    });

    setAttributes(target, {
      id: `acc-tab-${randomID}`,
      'aria-labelledby': `acc-btn-${randomID}`,
    });

    new Shower({
      target,
      handler,
      easing: 'easeInOutQuart',
      duration: 400,
      initOpened: false,
      openClassName: 'is-active',
    }).init();
  });
}

// ---------- init "check all checkboxes"

const checkAllCheckboxes = inputs => {
  inputs.forEach(input => {
    input.addEventListener('click', () => {
      const inputLabels = $$('label span', input.parentElement);
      const inputContainer = input.parentElement.parentElement;
      const siblingInputs = [
        ...$$('.input--checkbox:not(.input--check-all) input', inputContainer),
        ...$$('dl input', inputContainer),
      ];
      inputLabels.forEach(label => label.classList.toggle('is-hidden'));
      siblingInputs.forEach(sibling => (sibling.checked = input.checked));
    });
  });
};

const checkAllInputs = $$('.input--check-all input');
if (checkAllInputs.length) {
  checkAllCheckboxes(checkAllInputs);
}

// ---------- close tooltip on click outside

const tooltips = $$('.form__tooltip');
if (tooltips.length) {
  document.addEventListener('click', e => {
    tooltips.forEach(tooltip => {
      const isOpen = tooltip.hasAttribute('open');
      const tooltipText = $('p', tooltip);

      if (closest(e.target, 'summary')) return;

      if (isOpen && e.target !== tooltipText) {
        tooltip.removeAttribute('open');
      }
    });
  });
}

// ---------- init flatpickr

export class DatePicker {
  constructor(el, options = {}) {
    this.el = typeof el === 'string' ? $(el) : el;
    this.form = closest(this.el, 'form');
    this.isWrapper = this.el.nodeName !== 'INPUT';
    this.onChange = options.onChange || null;
    this.flastPickr = null;
  }

  getOptions = () => {
    const docLang = document.documentElement.lang;
    const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
    const localeOptions = lang === 'de' ? { locale: German } : null;
    const localeDateFormat = lang === 'de' ? 'd.m.Y' : 'Y-m-d';
    let elOptions;
    let options;

    try {
      const elOptionsFromDataset = JSON.parse(this.el.dataset.flatpickr);
      elOptions = {
        ...elOptionsFromDataset,
        ...localeOptions,
      };
    } catch {
      elOptions = localeOptions;
    }

    switch (this.el.dataset.flatpickrType) {
      case 'time':
        options = {
          enableTime: true,
          noCalendar: true,
          dateFormat: 'H:i',
          time_24hr: false,
        };
        break;
      case 'date':
        options = {
          dateFormat: localeDateFormat,
          minDate: 'today',
        };
        break;
      case 'dateFormatted':
        options = {
          dateFormat: 'd.m.Y',
          minDate: new Date().fp_incr(3),
          onChange(selectedDates, dateStr, instance) {
            if ($('.flatpickr-mobile', this.form)) {
              $('.flatpickr-mobile', this.form).setAttribute(
                'data-value',
                dateStr
              );
            }
          },
        };
        break;
      case 'datetime':
        options = {
          dateFormat: 'Z',
          minDate: 'today',
        };
        break;
      default:
        options = {};
    }

    return {
      wrap: this.isWrapper,
      allowInput: true,
      onChange: this.onChange,
      ...options,
      ...elOptions,
    };
  };

  onChanged = () => {
    this.onChange && this.onChange(this.flastPickr);
  };

  init() {
    this.flastPickr = flatpickr(this.el, this.getOptions());
    return this.flastPickr;
  }
}

const initDatepicker = form => {
  const dateInputs = $$('[data-flatpickr]:not(:disabled)');
  dateInputs.map(el => new DatePicker(el).init());

  // catch empty min attribute
  $$('[data-min-date-element-id]', form).forEach(el => {
    const minDateElementId = el.dataset.minDateElementId;
    if (minDateElementId) {
      $(`input#${minDateElementId}`, form).addEventListener('change', e => {
        el.setAttribute('min', e.target.value);
      });
    }
  });
};

const forms = $$('.form');

if (forms.length) {
  forms.forEach(form => {
    initDatepicker(form);
  });
}

// Toggle Input Fields for venue on option values 1, 2 and 3
const selectTogglesInput = $('#type');

if (selectTogglesInput) {
  const locationInput = $('#locationLink').closest('.form__element');
  const zipInput = $('#zip').closest('.form__element');
  const placeInput = $('#place').closest('.form__element');
  const streetInput = $('#street').closest('.form__element');
  const numberInput = $('#number').closest('.form__element');

  locationInput.style.display = 'none';
  zipInput.style.display = 'none';
  placeInput.style.display = 'none';
  streetInput.style.display = 'none';
  numberInput.style.display = 'none';

  selectTogglesInput.addEventListener('change', event => {
    const selected = event.target.value;

    if (selected === '1') {
      locationInput.style.display = 'none';
      zipInput.style.display = 'block';
      placeInput.style.display = 'block';
      streetInput.style.display = 'block';
      numberInput.style.display = 'block';
    } else if (selected === '2') {
      locationInput.style.display = 'block';
      zipInput.style.display = 'none';
      placeInput.style.display = 'none';
      streetInput.style.display = 'none';
      numberInput.style.display = 'none';
    } else {
      locationInput.style.display = 'block';
      zipInput.style.display = 'block';
      placeInput.style.display = 'block';
      streetInput.style.display = 'block';
      numberInput.style.display = 'block';
    }
  });
}
